import React, { useState } from 'react';
import Sidebar from './components/Sidebar';
import TopBar from './components/TopBar';
import InboxView from './views/InboxView';
import AnalyticsView from './views/AnalyticsView';
import EscalationBoard from './views/EscalationBoard';
import DemoView from './views/DemoView';

export default function App() {
  const [activeTab, setActiveTab] = useState('demo');

  const renderView = () => {
    switch (activeTab) {
      case 'inbox': return <InboxView />;
      case 'analytics': return <AnalyticsView />;
      case 'escalations': return <EscalationBoard />;
      case 'demo': return <DemoView />;
      default: 
        return (
          <div className="flex-1 flex items-center justify-center text-slate-500 bg-navy-900 border-l border-navy-700">
            Module "{activeTab}" is currently offline in this demo instance.
          </div>
        );
    }
  };

  return (
    <div className="flex h-screen bg-navy-900 overflow-hidden font-sans text-slate-300">
      <Sidebar activeTab={activeTab} setActiveTab={setActiveTab} />
      
      <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
        <TopBar />
        
        <main className="flex-1 relative overflow-hidden">
          {renderView()}
        </main>

        {/* Only show the floating credit when NOT in the scrolling Demo view */}
        {activeTab !== 'demo' && (
          <footer className="absolute bottom-4 right-4 z-50 text-[10px] text-slate-500 font-mono opacity-80 pointer-events-none tracking-widest uppercase">
            Made by LingLink AI and DigLab AI
          </footer>
        )}
      </div>
    </div>
  );
}